export const pollImageData = [
  {
    id: 1,
    image: require('./image1.jpg'),
    alt: 'Image 1',
    secret: "Object Level"
  },
  {
    id: 2,
    image: require('./image2.jpg'),
    alt: 'Image 2',
    secret: "Real"
  },
  {
    id: 3,
    image: require('./image3.jpg'),
    alt: 'Image 3',
    secret: "Person + Object + Scene Level"
  },
  {
    id: 4,
    image: require('./image4.jpg'),
    alt: 'Image 4',
    secret: "Person+Scene Level"
  },
  {
    id: 5,
    image: require('./image5.jpg'),
    alt: 'Image 5',
    secret: "Person-Level"
  },
  {
    id: 6,
    image: require('./image6.jpg'),
    alt: 'Image 7',
    secret: "Person-Object-Level"
  },
  {
    id: 7,
    image: require('./image7.jpg'),
    alt: 'Image 7',
    secret: "Scene Level"
  },
];